<template>
	<div>
		<vxe-modal v-model="modal_model" :title="title" :width="modal_width" :height="modal_height"
			@show="modal_onshow" show-footer @hide="modal_onhide" destroy-on-close :loading="loading">
			<template #default>
				<el-tabs v-model="activeName" type="card" @tab-click="handleClick" class="full" style="position: relative;" v-if="isready">
					<el-tab-pane label="原票" name="invoice" v-if="tab.includes('invoice')">
						<div style="position: relative;width: 1160px;height: 650px;margin: auto;">
							<sourcefile :invoicedata="invoicedata" />
						</div>
					</el-tab-pane>
					<el-tab-pane label="明细" name="detail" v-if="tab.includes('detail')">
						<div style="position: relative;width: 1160px;height: 650px;margin: auto;">
							<detail :invoicedata="invoicedata" :store="store" />
						</div>
					</el-tab-pane>
					<el-tab-pane label="单位转换" name="transferunit" v-if="tab.includes('transferunit')">
						<div style="position: relative;width: 1160px;height: 650px;margin: auto;">
							<transferunit :invoicedata="invoicedata" @transferunitSave="transferunitSave" />
						</div>
					</el-tab-pane>
					<el-tab-pane label="匹配存货" name="matchinventory" v-if="tab.includes('matchinventory')">
						<div style="position: relative;width: 1160px;height: 650px;margin: auto;">
							<matchinventory ref="matchinventory" :invoicedata="invoicedata" :store="store" />
						</div>
					</el-tab-pane>
					<el-tab-pane label="存货报表" name="inventory" v-if="tab.includes('inventory')">
						<div style="position: relative;width: 1160px;height: 650px;margin: auto;">
							<inventory :invoicedata="invoicedata" :store="store" />
						</div>
					</el-tab-pane>
					<el-tab-pane label="出库成本余额" name="invoicesuggestion" v-if="tab.includes('invoicesuggestion')">
						<div style="position: relative;width: 1160px;height: 650px;margin: auto;">
							<invoicesuggestion :invoicedata="invoicedata"  :store="store"/>
						</div>
					</el-tab-pane>
				</el-tabs>
<!-- 				<vxe-grid v-if="list_gridOptions" v-bind="list_gridOptions"
					@toolbar-button-click="list_toolbarButtonClickEvent"></vxe-grid> -->
			</template>
			<template #footer>
				<vxe-button status="" content="返回" @click="modal_cancel"></vxe-button>
			</template>
		</vxe-modal>
	</div>
</template>
<style scoped>

</style>
<script>
	import listMixins from '@_system/components/base/mixins/list/list.js'
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	import sourcefile from './sourcefile/index.vue'
	import transferunit from './transferunit/index.vue'
	import matchinventory from './matchinventory/index.vue'
	import inventory from './inventory/index.vue'
	import detail from './detail/index.vue'
	import invoicesuggestion from './invoicesuggestion/index.vue'
	export default {
		mixins: [listMixins, modalMixins],
		props: {
			data: {
				default: () => {
					return []
				}
			},
			invoicedata: {
				default: () => {
					return {}
				}
			},
			tab: {
				default: () => {
					return ['invoice','detail','transferunit','matchinventory','inventory','invoicesuggestion']
				}
			},
			title: {
				default: () => {
					return '发票信息'
				}
			},
		},
		data() {
			return {
				isready:false,
				loading:false,
				// invoicedata:{
				// 	customerId:'1906331305643',
				// 	// invoiceId:'5447535746'
				// 	invoiceId:'5448546022,5430321838,5429098294,5428558395,5450486871,5449821944,5446150484,5432590942,5432756674,5464470131,5424689038,5381809226,5429402660,5452781431,5452781430,5443480280,5441900288,5447535746,5441900289,5430570047,5454627553,5414829356,5425216967,5438099782,5438402322,5374003064,5472898398,5428898232,5460585173,5396638768,5453251637,5424922321,5435478316,5441900421,5433818232,5437600047,5473691487,5455389816,5428558397,5428558396,5368544692,5460585218,5470335623,5434784086,5434784087,5368904817,5392748868,5392748869,5455389817,5448860247,5421676414,5465191067,5469573445,5425795113,5424689039,5464188223'
				// },
				invoiceurl: null,
				activeName:'',
				modal_model: false,
				// modal_title: '进项入库',
				modal_width: 1200,
				modal_height: 800,
				store:{
					inventory:[],
					inventoryreport:[]
				}
				// list_footerField:[
				// 	{field:'needamount',toFixed:2}
				// ]
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {
			
		},
		methods: {
			modal_init() {
				this.store.tradedata = []
				this.store.xwtradedata = []
				this.activeName = this.tab[0]
				this.loading = true
				
				this.$api.invoice.getinventory().then((res)=>{
					this.loading = false
					this.store.inventory = res					
					this.$api.invoice.getinventoryreport({
						invoiceId:this.invoicedata.invoiceId,
						invoiceNumber:this.invoicedata.invoiceNumber,
						type:this.invoicedata.type,
					}).then((res)=>{
						this.store.inventoryreport = res
						this.isready = true
					},()=>{
						this.isready = true
					})					
				},()=>{
					this.loading = false
				})
			},
			handleClick(){
				
			},
			list_beforeCreateGrid(gridOptions) {
				gridOptions.columns = [{
						field: 'a',
						title: 'a',
					},
					{
						field: 'b',
						title: 'b'
					},
					{
						field: 'c',
						title: 'c',
					}
				]
				gridOptions.formConfig = false
			},
			list() {
				return new Promise((resolve) => {
					let data = []
					// let groupdata = this.$Lodash.groupBy(this.data, 'bankAcc')
					// for(let i in groupdata){
					// 	let obj = {}
					// 	obj.id = groupdata[i][0].id
					// 	obj.bankAcc = i
					// 	obj.accName = groupdata[i][0].accName
					// 	obj.needamount = this.$Lodash.sumBy(groupdata[i], item=>parseFloat(item.needamount))
					// 	obj.needamount = obj.needamount.toFixed(2)
					// 	data.push(obj)
					// }
					// console.log(data)
					resolve({
						list: data
					})
				})
			},
			transferunitSave(){
				this.$refs.matchinventory.customreload()
			},
			submit() {
				//this.init()
			},
			reset() {
				//this.init()
			}
		},
		components: {
			sourcefile,
			transferunit,
			matchinventory,
			inventory,
			detail,
			invoicesuggestion
		}
	}
</script>